import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.955 12.875a.726.726 0 0 1-.353.895l-.403.197c-1.854.76-3.091 1.033-3.982 1.033-2.287 0-2.293-1.797-4.543-1.797-.614 0-1.396.133-2.436.474-.497.162-1.155.393-1.155.393a.682.682 0 0 1-.216.036.715.715 0 0 1-.65-.425L4.054 4.025c-.143-.332.007-.679.357-.783l1.553-.46C7.722 2.216 8.966 2 9.87 2c3.107 0 2.213 2.57 4.413 2.57.445 0 1.016-.105 1.77-.357.192-.063 1.634-.512 1.634-.512a.648.648 0 0 1 .2-.03c.277 0 .545.17.653.447l3.415 8.757zM17.71 4.741l-.551.172c-.43.135-.721.226-.79.249-.82.274-1.502.408-2.086.408-1.214 0-1.85-.469-2.53-1.481a29.584 29.584 0 0 0-.161-.24C11.148 3.202 10.824 3 9.87 3c-.848 0-2.027.229-3.622.74l-1.089.323 3.867 8.968.536-.183.05-.017.314-.104c1.082-.354 1.979-.524 2.748-.524 1.203 0 1.863.313 2.864 1.103.703.556.996.694 1.679.694.814 0 1.974-.29 3.542-.931l.166-.081L17.71 4.74zm-15.672-.05a.5.5 0 0 1 .924-.381l7 17a.5.5 0 1 1-.924.38l-7-17z"
});

var SvgFlag = function SvgFlag(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgFlag;